import React from 'react'

import Calendar from './Calendar'

const DashboardPage = () => (
  <Calendar />
)

export default DashboardPage